import React, { Fragment } from "react";
import ClassyDonationImpact from "./ClassyDonationImpact";
import { intergerRegexDecimal } from "../../helpers/regex";

const ClassyDonateAmount = ({ register, amount, errors, impactFields }) => {

  return (
    <Fragment>
      <div className="ClassyDonate-impactWrapper">
        <ClassyDonationImpact impactFields={impactFields} />
      </div>

      <fieldset className="ClassyDonate-recurring">
        <legend className="ClassyDonate-recurring-legend c-violet-dark" style={{ marginBottom: "20px"}}>Make your life-giving donation today</legend>

        <div className="ClassyDonate-recurring-inputs">
          <input
            type="radio"
            id="recurringNo"
            name="recurring"
            value="0"
            defaultChecked={true}
            ref={register}
          />
          <label htmlFor="recurringNo">Give once</label>

          <input
            type="radio"
            id="recurringYes"
            name="recurring"
            value="1"
            ref={register}
          />
          <label htmlFor="recurringYes">Give monthly</label>
        </div>
      </fieldset>

      <fieldset className="ClassyDonate-amountsWrapper">
        <legend className="u-screenreader">Amount</legend>

        <div className="ClassyDonate-amounts">
          <div>
            <input
              type="radio"
              id="amount25"
              name="amount"
              value="25"
              ref={register}
            />
            <label htmlFor="amount25">$25</label>
          </div>

          <div>
            <input
              type="radio"
              id="amount50"
              name="amount"
              value="50"
              defaultChecked
              ref={register}
            />
            <label htmlFor="amount50">$50</label>
          </div>

          <div>
            <input
              type="radio"
              id="amount100"
              name="amount"
              value="100"
              ref={register}
            />
            <label htmlFor="amount100">$100</label>
          </div>

          <div>
            <input
              type="radio"
              id="amount250"
              name="amount"
              value="250"
              ref={register}
            />
            <label htmlFor="amount250">$250</label>
          </div>

          <div>
            <input
              type="radio"
              id="amount500"
              name="amount"
              value="500"
              ref={register}
            />
            <label htmlFor="amount500">$500</label>
          </div>

          <div>
            <input
              type="radio"
              id="otherAmount"
              name="amount"
              value="other"
              ref={register}
            />
            <label htmlFor="otherAmount">Other amount</label>
          </div>
        </div>

        {amount === "other" && (
          <div className="ClassyDonate-customAmount">
            <label htmlFor="customAmount">
              Donation amount
              {errors.otherAmount && (
                <span data-validate="error">
                  Please provide a valid dollar amount. Do not include commas,
                  periods, or other special characters.
                </span>
              )}
            </label>
            <input
              id="customAmount"
              name="otherAmount"
              inputMode="numeric"
              placeholder="Enter amount"
              type="text"
              ref={register({
                required: true,
                pattern: intergerRegexDecimal,
              })}
            />
          </div>
        )}
      </fieldset>

    </Fragment>
  );
};

export default ClassyDonateAmount;
